import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './Pages/HomePage/HomePage';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';

export default function App() {
  const LoadingMessage = () => {
    return <div>Loading..,</div>;
  };
  return (
    <BrowserRouter>
      <Header />

      <Suspense fallback={<LoadingMessage />}>
        <Routes>
          <Route path='/' element={<HomePage />} />
        </Routes>
      </Suspense>

      <Footer />
    </BrowserRouter>
  );
}
